import { Box, styled } from '@withjoy/joykit';

export const ContentContainer = styled(Box)`
  h2,
  h3,
  h4 {
    margin: ${({ theme }) => theme.space[8]} 0 ${({ theme }) => theme.space[6]};
  }

  p {
    margin: ${({ theme }) => theme.space[4]} 0;
  }

  & > *:first-child {
    margin-top: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;
